/** Static docs served from /public/docs — keep out of the webpack JS graph. */
export const WHITEPAPERS = {
  en: "/docs/WhitepaperFlashTechnologies.pdf",
  fr: "/docs/WhitePaperFR.pdf",
  de: "/docs/WhitePaperDE.pdf",
  es: "/docs/WhitePaperES.pdf",
  pt: "/docs/WhitePaperPT.pdf",
  ar: "/docs/WhitePaperAR.pdf",
};

/** @deprecated Use getWhitepaperPdf() */
export const WHITEOBAPER_EN = WHITEPAPERS.en;
/** @deprecated Use getWhitepaperPdf() */
export const WHITEOBAPER_FR = WHITEPAPERS.fr;

function viewerUrl(file, title) {
  return `/docs/view.html?file=${encodeURIComponent(file)}&title=${encodeURIComponent(title)}&v=wp2026`;
}

export function getWhitepaperPdf(lang) {
  const path = WHITEPAPERS[lang] || WHITEPAPERS.en;
  const file = path.split("/").pop();
  return viewerUrl(file, "Whitepaper");
}

export const PRIVACY_PDF = viewerUrl("LLC.pdf", "Privacy Policy");
export const LEGAL_NOTICE_PDF = viewerUrl("LNotice.pdf", "Legal Notice");
